import React, { useEffect, useMemo, useState } from 'react';

const ResearchApp = () => {
  const [research, setResearch] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    let cancelled = false;

    fetch('/research/metadata.json')
      .then((response) => response.json())
      .then((data) => {
        if (cancelled) return;
        setResearch(Array.isArray(data.research) ? data.research : []);
      })
      .catch(() => {
        if (!cancelled) setResearch([]);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  const activePaper = useMemo(() => research[activeIndex] || research[0] || null, [research, activeIndex]);

  return (
    <div className="research-lab-shell">
      <div className="research-lab-header">
        <div>
          <p className="research-lab-kicker">Research</p>
          <h2 className="research-lab-title">A lab board for the ideas behind the work.</h2>
          <p className="research-lab-copy">
            Papers and projects are pinned like lab notes, select one to inspect the abstract, status, and the skills orbiting it.
          </p>
        </div>
        <div className="research-lab-count">{research.length} notes</div>
      </div>

      <div className="research-lab-layout">
        <div className="research-lab-board-wrapper">
          <div className="research-lab-board">
            {research.map((paper, index) => {
              const active = index === activeIndex;
              return (
                <button
                  key={`${paper.title}-${index}`}
                  type="button"
                  className={`research-lab-card${active ? ' active' : ''}`}
                  onClick={() => setActiveIndex(index)}
                >
                  <span className="research-lab-card-pin" />
                  <span className="research-lab-card-status" style={{ color: paper.status === 'inProgress' ? '#FFB74D' : 'var(--text-muted)' }}>
                    {paper.status === 'inProgress' ? 'In progress' : 'Published'}
                  </span>
                  <h3 className="research-lab-card-title">{paper.title}</h3>
                  <p className="research-lab-card-venue">{paper.venue}</p>
                </button>
              );
            })}
          </div>
        </div>

        {activePaper && (
          <div className="research-lab-sheet">
            <div className="research-lab-sheet-header">
              <div>
                <p className="research-lab-sheet-kicker">{activePaper.status === 'inProgress' ? 'In progress' : 'Published'}</p>
                <h3 className="research-lab-sheet-title">{activePaper.title}</h3>
              </div>
              <div className="research-lab-sheet-meta">
                <span>{activePaper.venue}</span>
                <span>{activePaper.authors}</span>
              </div>
            </div>
            <p className="research-lab-sheet-abstract">{activePaper.abstract}</p>
            {Array.isArray(activePaper.keywords) && activePaper.keywords.length > 0 && (
              <div className="research-lab-keywords">
                {activePaper.keywords.map((keyword) => (
                  <span key={keyword} className="research-lab-keyword">{keyword}</span>
                ))}
              </div>
            )}
            {activePaper.attachment?.url && (
              <a href={activePaper.attachment.url} target="_blank" rel="noreferrer" className="research-lab-link">
                {activePaper.attachment.label || 'View paper'} →
              </a>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default ResearchApp;
